export enum ContactMethods {
  Email = 'email',
  Phone = 'phone',
  Sms = 'sms',
}
